export const imagesKeys = {
    "header.logo": {
        "large": 'assets/images/logo_main.svg',
        "small": 'assets/images/logo_main_small.svg',
    },
    "main.casino": {
        "large": 'assets/images/casino_desktop.png',
        "small": 'assets/images/casino_mobile.png',
    },
    "main.sport": {
        "large": 'assets/images/sport_desktop.png',
        "small": 'assets/images/sport_mobile.png',
    },
    "main.vip": {
        "large": 'assets/images/vip_desktop.png',
        "small": 'assets/images/vip_mobile.png',
    },
};
